import actiontypes from '../actiontypes'
import _ from 'common-tools/LodashHelper'

let actions = {}

actions[actiontypes.AppState.SetValue] = (state, action) => {
  if (!action.payload.key) {
    throw new Error('Invalid key for app state!')
  }

  let newState = _.merge({}, state)

  let newkeystate = newState[action.payload.key]
  if (!newkeystate) {
    newkeystate = {}
    newState[action.payload.key] = newkeystate
  }
  _.set(newkeystate, action.payload.prop, action.payload.value)
  return newState
}

actions[actiontypes.AppState.AppendArrayValue] = (state, action) => {
  if (!action.payload.key) {
    throw new Error('Invalid key for app state!')
  }

  let newState = _.merge({}, state)

  let newkeystate = newState[action.payload.key]
  if (!newkeystate) {
    newkeystate = {}
    newState[action.payload.key] = newkeystate
  }

  let currentValue = _.get(newkeystate, action.payload.prop)
  let newCurrentValue = _.clone(currentValue)

  if (_.isArray(newCurrentValue) === false) {
    throw new Error('App state key is not an array with is required for append, use set instead!')
  }
  newCurrentValue = _.concat(newCurrentValue, action.payload.value)

  _.set(newkeystate, action.payload.prop, newCurrentValue)
  return newState
}

actions[actiontypes.AppState.UpdateArrayValue] = (state, action) => {
  if (!action.payload.key) {
    throw new Error('Invalid key for app state!')
  }

  let newState = _.merge({}, state)

  let newkeystate = newState[action.payload.key]
  if (!newkeystate) {
    newkeystate = {}
    newState[action.payload.key] = newkeystate
  }

  let currentArrayValue = _.get(newkeystate, action.payload.prop)
  let newArrayValue = _.clone(currentArrayValue)

  if (_.isArray(newArrayValue) === false) {
    throw new Error('App state key is not an array which is required for append, use set instead!')
  }

  let matches = _.filter(newArrayValue, action.payload.filterFunction)

  if (_.isFunction(action.payload.updateFunction)) {
    _.forEach(matches, (m) => {
      action.payload.updateFunction(m)
    })
  }

  if (_.isFunction(action.payload.modifyFunction)) {
    newArrayValue = action.payload.modifyFunction(matches)
  }

  _.set(newkeystate, action.payload.prop, newArrayValue)
  return newState
}

actions[actiontypes.AppState.ClearValue] = (state, action) => {
  if (!action.payload.key) {
    throw new Error('Invalid key for app state!')
  }

  let newState = _.merge({}, state)

  if (!action.payload.prop) {
    delete (newState[action.payload.key])
  } else {
    let foundKey = newState[action.payload.key]
    if (foundKey) {
      delete (foundKey[action.payload.prop])
    }
  }
  return newState
}

export default (state = {
}, action) => {
  if (_.startsWith(action.type, actiontypes.AppState.Prefix)) {
    return actions[action.type](state, action)
  } else {
    return state
  }
}
